export const toClassName = (...args) => args?.join(' ');
